export default {
	title: "Funções",
	description: "Gerenciar funções espirituais e administrativas do terreiro",
	searchPlaceholder: "Buscar funções...",
	create: "Nova Função",
	deleteConfirmation: "Tem certeza que deseja excluir a função {name}?",
	deleteWarning: "Esta ação é permanente. Todos os vínculos de pessoas com esta função serão removidos.",
	confirmDeleteMessage: "Tem certeza que deseja excluir esta função? Esta ação não pode ser desfeita.",
	name: "Nome",
	category: "Categoria",
	noCategory: "Sem categoria",
	newCategory: "Nova categoria",
	personCount: "Pessoas Atribuídas",
	peopleCount: "Pessoas",
	minimumJourney: "Jornada Mínima",
	noRequirement: "Sem Requisito",
	function: "Função",
	notes: "Observações",
	noFunctions: "Esta pessoa não possui funções atribuídas",
	since: "Desde",
	deactivate: "Desativar",
	reactivate: "Reativar",
	endedAt: "Finalizado em",
	addFunction: "Adicionar Função",
	selectFunction: "Selecionar Função",
	requiredStage: "Estágio Req",
	minimumJourneyStageRequired: "Requer estágio mínimo: {stage}",
	journeyStageNotMet: "Estágio atual ({current}) não atende o requisito mínimo ({required})",
	noCurrentStage: "Sem estágio",
	currentJourneyStage: "Estágio Atual da Jornada",
	minimumJourneyStage: "Estágio Mínimo de Jornada",
	minimumJourneyStageHint: "Estágio mínimo necessário para exercer esta função (opcional)",
	status: {
		active: "Ativa",
		inactive: "Inativa",
		all: "Todas",
	},
	empty: {
		title: "Nenhuma função encontrada",
		description: "Cadastre as funções espirituais e administrativas do terreiro",
	},
	stats: {
		total: "Total",
		withPersons: "Com Pessoas",
		withoutPersons: "Sem Pessoas",
	},
	messages: {
		activated: "Função ativada com sucesso",
		deactivated: "Função desativada com sucesso",
		createError: "Erro ao criar função",
		deleteError: "Erro ao excluir função",
		fetchError: "Erro ao carregar funções",
		loadError: "Erro ao carregar funções",
		saveError: "Erro ao salvar função",
		createSuccess: "Função criada com sucesso",
		updateSuccess: "Função atualizada com sucesso",
		deleteSuccess: "Função excluída com sucesso",
	},
};
